import React, { useState, useRef } from 'react';
import { Scanner } from '@yudiel/react-qr-scanner';
import { Box, Paper, Typography, Alert, Chip } from '@mui/material';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';

const QRScanner = ({ onScanSuccess, onScanError }) => {
  const [error, setError] = useState('');
  const [scanning, setScanning] = useState(false);
  const lastScanRef = useRef('');
  const lastScanTimeRef = useRef(0);

  const handleScan = (detectedCodes) => {
    console.log('QR Scanner - Detected codes:', detectedCodes);

    if (detectedCodes && detectedCodes.length > 0) {
      const decodedText = detectedCodes[0].rawValue;
      const now = Date.now();

      console.log('QR Scanner - Decoded text:', decodedText);

      // Prevent duplicate scans within 2 seconds
      if (decodedText === lastScanRef.current && now - lastScanTimeRef.current < 2000) {
        console.log('QR Scanner - Duplicate scan ignored');
        return;
      }

      lastScanRef.current = decodedText;
      lastScanTimeRef.current = now;
      setError('');
      setScanning(true);

      console.log('QR Scanner - Calling onScanSuccess');
      if (onScanSuccess) {
        onScanSuccess(decodedText);
      }
    }
  };

  const handleError = (err) => {
    console.error('QR Scanner - Error:', err);
    if (err) {
      const errorMessage = err?.message || 'Failed to access camera';
      setError(errorMessage);
      if (onScanError) {
        onScanError(errorMessage);
      }
    }
  };

  return (
    <Box>
      {error && (
        <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError('')}>
          {error}
        </Alert>
      )}

      <Paper elevation={3} sx={{ p: 2, overflow: 'hidden' }}>
        <Box display="flex" alignItems="center" justifyContent="center" gap={1} mb={2}>
          <QrCodeScannerIcon color="primary" />
          <Typography variant="h6" align="center">
            Scan QR Code
          </Typography>
          {scanning && (
            <Chip
              label="Scanning..."
              color="success"
              size="small"
              sx={{ ml: 1 }}
            />
          )}
        </Box>
        <Typography variant="body2" color="text.secondary" align="center" sx={{ mb: 2 }}>
          Position the QR code in the camera view
        </Typography>

        <Box
          sx={{
            width: '100%',
            maxWidth: '600px',
            margin: '0 auto',
            '& video': {
              width: '100%',
              maxWidth: '100%',
              height: 'auto'
            }
          }}
        >
          <Scanner
            onScan={handleScan}
            onError={handleError}
            formats={['qr_code']}
            paused={false}
            constraints={{
              facingMode: 'environment'
            }}
            components={{
              audio: false,
              finder: true,
              torch: true
            }}
            allowMultiple={false}
            scanDelay={100}
          />
        </Box>
      </Paper>
    </Box>
  );
};

export default QRScanner;
